import React from "react";
import classNames from "classnames";
import { View } from "../_core/components";
import { useConfig } from "../_util/use-config";
export function Badge(_a) {
    var _b;
    var children = _a.children, info = _a.info, dot = _a.dot, color = _a.color, square = _a.square, className = _a.className, style = _a.style;
    var classPrefix = useConfig().classPrefix;
    return (React.createElement(View, { className: classNames(classPrefix + "-badge", className), style: style },
        children,
        dot && React.createElement(View, { className: classPrefix + "-badge__dot" }),
        !dot && info && (React.createElement(View, { className: classNames(classPrefix + "-badge__info", (_b = {},
                _b[classPrefix + "-badge__info--square"] = square,
                _b)), style: { backgroundColor: color } }, info))));
}
//# sourceMappingURL=Badge.js.map